import { render, staticRenderFns } from "./keyword.vue?vue&type=template&id=36b7dfd7&scoped=true"
import script from "./keyword.vue?vue&type=script&lang=js"
export * from "./keyword.vue?vue&type=script&lang=js"
import style0 from "./keyword.vue?vue&type=style&index=0&id=36b7dfd7&prod&lang=scss&scoped=true"
import style1 from "./keyword.vue?vue&type=style&index=1&id=36b7dfd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b7dfd7",
  null
  
)

export default component.exports